<template>
  <div>
    <Modal :value="visible" title="商品查询" width="800" @on-visible-change="handleVisibleChange">
      <div>
        <Input
          v-model="goodsSearchId"
          placeholder="输入商品ID"
          style="width: 200px; margin-right: 10px"
        />
        <Input
          v-model="goodsSearchName"
          placeholder="输入商品名称"
          style="width: 200px; margin-right: 10px"
        />
        <Select
          v-model="goodsSearchType"
          placeholder="请选择商品分类"
          style="width: 200px; margin-right: 10px"
        >
          <Option value="">未选择</Option>
          <Option
            v-for="item in innerGoodsTypeOptions"
            :value="item.value"
            :key="item.value"
            >{{ item.label }}</Option
          >
        </Select>
        <Button type="primary" @click="searchProducts">查询</Button>
      </div>

      <Table :columns="goodsColumns" :data="goodsData">
        <template slot="footer">
          <div style="margin: 10px; overflow: hidden">
            <div style="float: right">
              <Page
                :total="goodsTotal"
                :current="goodsCurrent"
                :page-size="10"
                @on-change="changeGoodsPage"
              ></Page>
            </div>
          </div>
        </template>
      </Table>

      <div slot="footer">
        <Button @click="close">取消</Button>
      </div>
    </Modal>

    <Modal v-model="editModal" title="编辑商品" width="360" :loading="editLoading">
      <div style="text-align: center">
        <Form :label-width="120">
          <FormItem label="商品名称">
            <Input v-model="editForm.goodsname" placeholder="请输入商品名称" />
          </FormItem>
          <FormItem label="商品市场价">
            <Input v-model="editForm.marketp" placeholder="请输入商品市场价" />
          </FormItem>
          <FormItem label="商品成本价">
            <Input v-model="editForm.cost" placeholder="请输入商品成本价" />
          </FormItem>
          <FormItem label="分解成金币">
            <Input v-model="editForm.coinnum" placeholder="请输入分解成金币的数量" />
          </FormItem>
          <!-- <FormItem label="分解成能量">
            <Input v-model="editForm.integralnum" placeholder="请输入分解成能量的数量" />
          </FormItem> -->
          <FormItem label="商品分类">
            <Select v-model="editForm.goodstype" placeholder="请选择商品分类">
              <Option
                v-for="item in innerGoodsTypeOptions"
                :value="item.value"
                :key="item.value"
                >{{ item.label }}</Option
              >
            </Select>
          </FormItem>
        </Form>
      </div>
      <div slot="footer">
        <Button type="primary" @click="handleEditOk">提交</Button>
        <Button @click="handleEditCancel">取消</Button>
      </div>
    </Modal>
  </div>
</template>

<script>
import { cmsSelgoods, cmsUpdategoods } from "@/api/product";
import { formatOssUrl } from "@/utils";

export default {
  name: "GoodsSearchModal",
  props: {
    // 控制弹窗显示，由父组件传入，使用 :visible.sync 绑定
    visible: {
      type: Boolean,
      default: false,
    },
    // 商品分类选项，可选；不传则默认用 this.$goodsTypeOptions
    goodstypeOptions: {
      type: Array,
      default() {
        return [];
      },
    },
    // 是否在操作列中显示“编辑”按钮
    showEdit: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      goodsSearchId: "",
      goodsSearchName: "",
      goodsSearchType: "",
      goodsData: [],
      goodsTotal: 0,
      goodsCurrent: 1,
      editModal: false,
      editLoading: false,
      editForm: {
        id: "",
        goodsname: "",
        marketp: "",
        cost: "",
        coinnum: "",
        integralnum: "",
        goodsimg: "",
        goodsimg2: "",
        goodstype: "",
        issend: 0,
      },
      goodsColumns: [
        {
          title: "商品id",
          key: "id",
        },
        {
          title: "商品名称",
          key: "goodsname",
        },
        {
          title: "封面图片",
          key: "image",
          render: (h, params) => {
            return h("img", {
              attrs: {
                src: formatOssUrl(params.row.goodsimg),
              },
              style: {
                width: "50px",
                height: "50px",
                marginTop: "5px",
              },
            });
          },
        },
        {
          title: "商品分类",
          key: "goodstype",
        },
        {
          title: "商品数量",
          key: "goodsnum",
        },
        {
          title: "分解币数",
          key: "coinnum",
        },
        {
          title: "操作",
          key: "action",
          width: 150,
          align: "center",
          render: (h, params) => {
            const buttons = [];

            // 选择按钮
            buttons.push(
              h(
                "Button",
                {
                  props: {
                    type: "primary",
                    size: "small",
                  },
                  style: {
                    marginRight: this.showEdit ? "5px" : "0px",
                  },
                  on: {
                    click: () => {
                      this.handleSelectGoods(params.row);
                    },
                  },
                },
                "选择"
              )
            );

            
              buttons.push(
                h(
                  "Button",
                  {
                    props: {
                      type: "primary",
                      size: "small",
                    },
                    on: {
                      click: () => {
                        this.handleEditGoods(params.row);
                      },
                    },
                  },
                  "编辑"
                )
              );
            

            return h("div", buttons);
          },
        },
      ],
    };
  },
  computed: {
    // 内部使用的商品分类选项
    innerGoodsTypeOptions() {
      if (this.goodstypeOptions && this.goodstypeOptions.length > 0) {
        return this.goodstypeOptions;
      }
      return this.$goodsTypeOptions || [];
    },
  },
  watch: {
    // 弹窗一旦打开，自动查询一次
    visible(val) {
      if (val) {
        this.resetAndSearch();
      }
    },
  },
  methods: {
    handleVisibleChange(val) {
      // 与父组件同步 visible 值，支持 :visible.sync
      this.$emit("update:visible", val);
    },
    close() {
      this.$emit("update:visible", false);
    },
    resetAndSearch() {
      this.goodsSearchId = "";
      this.goodsSearchName = "";
      this.goodsSearchType = "";
      this.goodsCurrent = 1;
      this.searchProducts();
    },
    searchProducts() {
      const params = {
        id: this.goodsSearchId || undefined,
        goodsname: this.goodsSearchName || undefined,
        goodstype: this.goodsSearchType || undefined,
        page: this.goodsCurrent,
      };

      cmsSelgoods(params)
        .then((response) => {
          this.goodsData = response.data.rows;
          this.goodsTotal = response.data.pagination.total;
          this.goodsCurrent = response.data.pagination.page;
        })
        .catch((error) => {
          this.$Message.error("获取商品列表失败");
          console.error(error);
        });
    },
    changeGoodsPage(page) {
      this.goodsCurrent = page;
      this.searchProducts();
    },
    handleSelectGoods(goods) {
      // 把选中的商品对象抛给父组件，父组件里各自处理
      this.$emit("select-goods", goods);
      this.close();
      this.$Message.success("已选择商品：" + goods.goodsname);
    },
    handleEditGoods(goods) {
      this.editForm = {
        id: goods.id,
        goodsname: goods.goodsname || "",
        marketp: goods.marketp || "",
        cost: goods.cost || "",
        coinnum: goods.coinnum || "",
        integralnum: goods.integralnum || "",
        goodsimg: goods.goodsimg || "",
        goodsimg2: goods.goodsimg2 || "",
        goodstype: goods.goodstype || "",
        issend: goods.issend != null ? parseInt(goods.issend) : 0,
      };
      this.editModal = true;
    },
    handleEditOk() {
      this.editLoading = true;
      cmsUpdategoods(this.editForm)
        .then(() => {
          this.$Message.success("商品修改成功！");
          this.editModal = false;
          this.searchProducts();
        })
        .catch((error) => {
          this.$Message.error("商品修改失败！");
          console.error(error);
        })
        .finally(() => {
          this.editLoading = false;
        });
    },
    handleEditCancel() {
      this.editModal = false;
    },
  },
};
</script>
